import AssignLessonsRequestModelBase from '../_generated/modelBases/assign-lessons-request-model-base';

export default class AssignLessonsRequestModel extends AssignLessonsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
